import { render, staticRenderFns } from "./headItem.vue?vue&type=template&id=3b018e5c&scoped=true&"
import script from "./headItem.vue?vue&type=script&lang=js&"
export * from "./headItem.vue?vue&type=script&lang=js&"
import style0 from "./headItem.vue?vue&type=style&index=0&id=3b018e5c&style=true&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b018e5c",
  null
  
)

component.options.__file = "headItem.vue"
export default component.exports